// extracted by mini-css-extract-plugin
export default {"manualCallbacksSection":"ManualCallbacks_manualCallbacksSection__BKnQ0"};